<template>
  <div
    v-if="value"
    class="infoBlock"
  >
    <div
      class="label"
      :data-automation="dataAutomation + '-label'"
    >
      {{ label }}
    </div>
    <div
      :data-automation="dataAutomation + '-value'"
      v-html="convertedValue"
    />
  </div>
</template>

<script>

import linkifyString from 'linkifyjs/string'

export default {
  name: 'InfoBlockTextWithLinks',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      required: true,
      type: String,
      default: 'empty',
    },
    dataAutomation: {
      type: String,
      required: false,
      default: 'empty',
    },
  },
  computed: {
    convertedValue: function () {
      return linkifyString(this.value, { target: '_blank', attributes: { 'data-automation': 'package-url' } })
    },
  },
}

</script>
